import * as Yup from 'yup'
import { CONFIGURATION_TYPE } from '@interfaces/configurations/enums/configurationType'

export interface IConfigSchema {
    configName: CONFIGURATION_TYPE | null
    file: File | null | undefined
    signedUrl: string
}

const configSchema: Yup.SchemaOf<IConfigSchema> = Yup.object().shape({
    configName: Yup.mixed<CONFIGURATION_TYPE>().oneOf(Object.values(CONFIGURATION_TYPE)).required(),
    file: Yup.mixed<File>().nullable(true),
    signedUrl: Yup.string().default('')
})

export default configSchema